import { isNativeApp } from './platform';

/** Открыть внешнюю ссылку. window.open часто режется WebView / попап-блокером. */
export function openExternalUrl(url) {
  if (!url) return;
  if (isNativeApp()) {
    try {
      window.open(url, '_system');
      return;
    } catch {
      /* fall through */
    }
  }
  try {
    const opened = window.open(url, '_blank');
    if (opened) {
      try {
        opened.opener = null;
      } catch (_) {
        /* ignore */
      }
      return;
    }
  } catch (_) {
    /* ignore */
  }
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.style.position = 'fixed';
  a.style.left = '-9999px';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
